import api from './api';

// Get all report requests (with role-based filtering)
export const getReportRequests = async () => {
  const response = await api.get('/report-requests');
  return response;
};

// Create a new report request
export const createReportRequest = async (requestData) => {
  const response = await api.post('/report-requests', requestData);
  return response;
};

// Approve a report request (admin only)
export const approveReportRequest = async (requestId) => {
  const response = await api.put(`/report-requests/${requestId}/approve`);
  return response;
};

// Reject a report request (admin only)
export const rejectReportRequest = async (requestId, rejectionReason) => {
  const response = await api.put(`/report-requests/${requestId}/reject`, { rejection_reason: rejectionReason });
  return response;
};
